document.querySelector("form").addEventListener("submit", function(e) {
  let pass = document.getElementById("password").value;
  let confirm = document.getElementById("confirm_password").value;
  let valid = /^(?=.*[A-Z])(?=.*[0-9])[A-Za-z0-9]{8,}$/.test(pass);

  if (!valid || pass !== confirm) {
    e.preventDefault();
    alert("Password must be 8+ chars, include 1 uppercase, 1 number, no special chars. And both passwords must match.");
  }
});
var input = document.querySelector("#phone");
window.intlTelInput(input, {
  initialCountry: "pk",
  utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.js"
});

// Active class on focus

$(document).ready(function () {
  $('section.register input.register__input').each(function () {
    const $label = $(this).siblings('.register__label');
    if ($label.length && $(this).val().trim() !== '') {
      $label.addClass('active');
    }
  });

  $(document).on('focus blur input', 'section.register input.register__input', function () {
    const $label = $(this).siblings('.register__label');
    $label.toggleClass('active', $(this).is(':focus') || $(this).val().trim() !== '');
  });
});


